export default __webpack_public_path__ + "static/media/nala.200f8681.webp";